module.exports = __webpack_public_path__ + "img/nothing-tip@3x.0f20b2e6.png";